var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skills"},_vm._l((_vm.mySkills),function(skill){return _c('span',{key:skill.name,staticClass:"tag skill",class:skill.type},[_vm._v(" "+_vm._s(skill.name)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }